import React__default, { useRef, useEffect } from 'react';
import styles from './PanelArea.scss.mjs';
import { useFrameContext } from '../../../FrameProvider/FrameProvider.mjs';
import { FrameAreaValue } from '../../../FrameProvider/types.mjs';

function PanelArea({
  children,
  disableDestination = false,
  frameArea = FrameAreaValue.SecondaryPanel
}) {
  // NOTE: `area` is required as a useEffect dependency
  // in order to reset the frameArea ("primary" or "secondary") correctly.
  const {
    area,
    setFrameAreaRef
  } = useFrameContext();
  const panelForFrameArea = area[frameArea];
  const panelAreaRef = useRef(null);
  useEffect(() => {
    if (!disableDestination) {
      setFrameAreaRef([frameArea, panelAreaRef]);
    }
    return () => disableDestination ? undefined : setFrameAreaRef([frameArea, null]);
  }, [panelForFrameArea, disableDestination, setFrameAreaRef, frameArea]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.PanelArea,
    ref: panelAreaRef
  }, children);
}

export { PanelArea };
